import { render, staticRenderFns } from "./task-reassign.vue?vue&type=template&id=6fc05ef4"
import script from "./task-reassign.vue?vue&type=script&lang=js"
export * from "./task-reassign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports